export { ListadoPT } from "./ListadoPT";

